module.exports = __webpack_public_path__ + "img/sankaku_59_red.5fbc0341.png";